import { render, staticRenderFns } from "./AppointmentScreenshot.vue?vue&type=template&id=dd9d277a&scoped=true&"
import script from "./AppointmentScreenshot.vue?vue&type=script&lang=js&"
export * from "./AppointmentScreenshot.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentScreenshot.vue?vue&type=style&index=0&id=dd9d277a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9d277a",
  null
  
)

export default component.exports